export default __webpack_public_path__ + "static/media/elevatorCoin.25b77142.svg";